import { FlexBox } from '@dixa/lib-shared-habla';
import { MessageInlineImage } from 'lib-shared-legacy-types';
import { memo } from 'react';

import { InlinedImage } from '../inlinedImage/inlinedImage';

type InlinedImagesProps = {
  files: MessageInlineImage[];
};

/** Takes inline images as object and renders them as {@link InlinedImage} */
export const InlinedImages = memo(function InlinedImages({
  files,
}: InlinedImagesProps): JSX.Element {
  if (!files.length) {
    return <></>;
  }
  return (
    <>
      <hr />
      <FlexBox gap="200" flexWrap="wrap" alignItems="stretch">
        {files.map((file, index) => (
          <div key={file.url}>
            <InlinedImage
              number={index}
              src={file.url}
              alt={file.pretty_name}
              attachedFileFallback
            />
          </div>
        ))}
      </FlexBox>
    </>
  );
});
